import _classCallCheck from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Web Clients and Images - Production/Code/WEB CLIENT - GTP 2.0 Deploy/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import GameInterface from './index';
import store from '../../state/store';
import { setSpinEvent } from '../../state/slices/spinEvent/spinEvent';
import SPIN_PHASE from './helpers/spinPhases';

var Everi = /*#__PURE__*/function (_GameInterface) {
  _inherits(Everi, _GameInterface);

  var _super = _createSuper(Everi);

  function Everi(args) {
    var _this;

    _classCallCheck(this, Everi);

    _this = _super.call(this, args);

    _this.jsonParserEvent = function (payload) {
      var _store$getState$playe = store.getState().playerInfo,
          playerId = _store$getState$playe.playerId,
          soundEffects = _store$getState$playe.soundEffects;
      var gameId = store.getState().gameInfo.gameId;
      var _store$getState$lastS = store.getState().lastSpinEvents.balanceAfter,
          balance = _store$getState$lastS === void 0 ? null : _store$getState$lastS;

      if (soundEffects !== _this.currentSoundSetting) {
        _this.setSound();
      }

      switch (payload.id) {
        case 'GAME_LOADED':
          _this.setSound();

          _this._gameReady();

          _this.sendAnalyticEvent();

          break;

        case 'WAGER':
          store.dispatch(setSpinEvent({
            playerId: playerId,
            createdTimestamp: Date.now(),
            spinPhase: SPIN_PHASE.WAGE,
            amount: payload.data.bet,
            gameId: gameId
          }));
          break;

        case 'INSUFFICIENT_FUND':
          _this._outOfCoins();

          _this.showOutOfCoinsScreen();

          break;

        case 'UNDEFINED_ERROR':
          var errorDescription = JSON.stringify(payload);

          _this.sendErrorCreatedEvent(errorDescription);

          break;

        case 'RESULT':
          if (payload.data.win > 0) {
            store.dispatch(setSpinEvent({
              playerId: playerId,
              createdTimestamp: Date.now(),
              spinPhase: SPIN_PHASE.WIN,
              gameId: gameId,
              amount: payload.data.win
            }));
          }

          _this._currentBet = parseInt(payload.data.bet);

          _this.AddSpinXP(_this._currentBet);

          store.dispatch(setSpinEvent({
            balanceBefore: balance ? balance : payload.data.balance,
            balanceAfter: payload.data.balance
          }));
          break;
      }
    };

    _this._currentRound = 0;
    _this._lastWinRound = 0;
    _this._currentBet = 0;
    _this.currentSoundSetting = false;
    return _this;
  }

  _createClass(Everi, [{
    key: "setSound",
    value: function setSound() {
      var soundEffects = store.getState().playerInfo.soundEffects;
      this.sendEvent(JSON.stringify({
        event: 'volume',
        volume: soundEffects
      }));
      this.currentSoundSetting = soundEffects;
    }
  }]);

  return Everi;
}(GameInterface);

export default Everi;